module.exports = __webpack_public_path__ + "static/media/background.fcbe39ee.jpg";